import React,{useEffect, useState, useContext} from 'react';
import {MyContext} from '../../login/MyContext';

import Inicio from '../inicio/Inicio';

import MaterialTable from 'material-table';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'reactstrap';
import axios from 'axios';

import Routes from '../../routes/Routes';


function Proveedores() {
  
  const baseUrlAd = Routes.global.url_proveedores; 
  const [data, setData]=useState([]);
  const [modalInsertar, setModalInsertar]=useState(false);
  const [modalEditar, setModalEditar]=useState(false);
  const [modalEliminar, setModalEliminar]=useState(false);
  const [frameworkSeleccionado, setFrameworkSeleccionado]=useState({
    id_proveedor:'',
    nombre:'',
    tdoc:'',
    documento:'',
    celular:'',
    email:'',
    direccion:''
  });

   
  const handleChange=e=>{
    const {name, value}=e.target;
    setFrameworkSeleccionado((prevState)=>({
      ...prevState,
      [name]: value
    }))
   console.log(frameworkSeleccionado);
  }

  const abrirCerrarModalInsertar=()=>{
    setModalInsertar(!modalInsertar);
  }

  const peticionGet =async() =>{
    await axios.get(baseUrlAd)
    .then(response=>{
     setData(response.data);
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPost = async() =>{
    var f = new FormData();
    f.append("nombre", frameworkSeleccionado.nombre);
    f.append("tdoc", frameworkSeleccionado.tdoc);
    f.append("documento", frameworkSeleccionado.documento);
    f.append("celular", frameworkSeleccionado.celular);
    f.append("email", frameworkSeleccionado.email);
    f.append("direccion", frameworkSeleccionado.direccion);
    f.append("METHOD", "POST_proveedor");
    await axios.post(baseUrlAd,f)
    .then(response=>{
     setData(data.concat(response.data));
     abrirCerrarModalInsertar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const peticionPut = async() =>{
    var f = new FormData();
    f.append("nombre", frameworkSeleccionado.nombre);
    f.append("tdoc", frameworkSeleccionado.tdoc);
    f.append("documento", frameworkSeleccionado.documento);
    f.append("celular", frameworkSeleccionado.celular);
    f.append("email", frameworkSeleccionado.email);
    f.append("direccion", frameworkSeleccionado.direccion);
    f.append("METHOD", "PUT_proveedor");
    await axios.post(baseUrlAd,f, {params: {id_proveedor: frameworkSeleccionado.id_proveedor}})
    .then(response=>{
     var dataNueva = data;
     dataNueva.map(framework=>{
       if(framework.id_proveedor===frameworkSeleccionado.id_proveedor){
         framework.nombre= frameworkSeleccionado.nombre;
         framework.tdoc= frameworkSeleccionado.tdoc;
         framework.documento= frameworkSeleccionado.documento;
         framework.celular= frameworkSeleccionado.celular;
         framework.email = frameworkSeleccionado.email;
         framework.direccion = frameworkSeleccionado.direccion;
       }
     });
     setData(dataNueva);
     abrirCerrarModalEditar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const abrirCerrarModalEditar=()=>{
    setModalEditar(!modalEditar);
  }

  const abrirCerrarModalEliminar=()=>{
    setModalEliminar(!modalEliminar);
  }



  const peticionDelete = async() =>{
    var f = new FormData();
    f.append("METHOD", "DELETE_proveedor");
    await axios.post(baseUrlAd,f, {params: {id_proveedor: frameworkSeleccionado.id_proveedor}})
    .then(response=>{
     setData(data.filter(framework=>framework.id_proveedor!==frameworkSeleccionado.id_proveedor));
     abrirCerrarModalEliminar();
    }).catch(error=>{
      console.log(error);
    })

  }

  const seleccionarFramework=(framework, caso)=>{
    setFrameworkSeleccionado(framework);
    (caso==="Editar")?
    abrirCerrarModalEditar():
    abrirCerrarModalEliminar()
  } 

  useEffect(()=>{
    const interval = setInterval(() => { 
       peticionGet();  
     }, 1000);
   return () => setInterval(interval);
   },[])

  

  
  const columnas =[
    {
      title:"ID",
      field: "id_proveedor",
      
    },
    {
      title:'NOMBRES',
      field:'nombre'
    },

    {
      title:'DOCUMENTO',
      field:'documento'
    },

    {
      title:'CELULAR',
      field:'celular'
    },
    {
      title:'EMAIL',
      field:'email'
    },

  ];

  const {rootState,logoutUser} = useContext(MyContext);
  const {isAuth,theUser,showLogin} = rootState;

  if(isAuth && theUser.rol =="usuario")
  {

    return (

        <div className="content-wrapper">
    
    <div className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h3 className="m-0"><button className="btn btn-primary" onClick={()=>abrirCerrarModalInsertar()}><i class="fas fa-plus-circle"></i> CREAR PROVEEDOR</button></h3>
          </div>
          <div className="col-sm-6">
            
          </div>
        </div>
      </div>
    </div>

   
    <section className="content">
      <div className="container-fluid">
        
        <div className="row">
        
          <div className="col-md-12">

         
            <div>
              
            <MaterialTable   
     
columns={columnas}
data={data}
title="PROVEEDORES"
backIconButtonText='Página anterior'
pagination
fixedHeader

actions={[
    
    {
        icon : 'edit',
        tooltip: 'Editar',
        onClick: (event, framework)=>seleccionarFramework(framework, "Editar")
    },

    {
       icon : 'delete',
       tooltip: 'Eliminar',
       onClick: (event, framework)=>seleccionarFramework(framework, "Eliminar")
    }
]}
options={{
  actionsColumnIndex: -1
}}
options={{
 actionsCellStyle: {
 },

 headerStyle: { backgroundColor: "#55C3F9",  headerStyle: { position: 'sticky'}, boxShadow:"0 0  0 2px rgb(255,255,255)", color: "white" }
}}
localization={{
    header:{
    actions: 'ACCIONES'
    
  },
  body:{ 
    emptyDataSourceMessage:'No hay registros que mostrar',
    
   },

 
   pagination: {
     firstAriaLabel: 'Primera página',
     firstTooltip: 'Primera página',
     labelDisplayedRows: '{from}-{to} de {count}',
     labelRowsPerPage: 'Filas por página:',
     labelRowsSelect: 'filas',
     lastAriaLabel: 'Ultima página',
     lastTooltip: 'Ultima página',
     nextAriaLabel: 'Pagina siguiente',
     nextTooltip: 'Pagina siguiente',
     previousAriaLabel: 'Pagina anterior',
     previousTooltip: 'Pagina anterior',
   },
   toolbar: {
     searchPlaceholder: 'Buscar',
     searchTooltip: 'Buscar',
     showColumnsAriaLabel: 'Mostrar columnas',
     showColumnsTitle: 'Mostrar columnas',
   },

   
}}

/>

<Modal isOpen={modalInsertar}>
 <ModalHeader><i class="fas fa-plus-circle"></i> CREAR PROVEEDOR</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">

   <div class="col-8">
     <label>Nombres:</label>
     <br/>
     <input type="text" className="form-control" name="nombre" onChange={handleChange}/>
     <br/>
     </div>

      <div class="col-sm-4">
      <label>T.doc:</label>
     <br/>
                    <select name="tdoc" className="form-control" onChange={handleChange}>
                    <option value='no' selected>T.doc</option>
                    <option value="Cedula">Cedula</option>
                    <option value="DNI">DNI</option>
                    <option value="T. identidad">T. identidad</option>
                    <option value="T. identidad">NIT</option>
                    </select>     
                    </div>

     </div>

     <div className="row">

   <div class="col-4">
     <label>Documento:</label>
     <br/>
     <input type="number" className="form-control" name="documento" onChange={handleChange}/>
     <br/>
     </div>

     <div class="col-4">
     <label>Celular:</label>
     <br/>
     <input type="number" className="form-control" name="celular" onChange={handleChange}/>
     <br/>
     </div>

     <div class="col-4">
     <label>Email:</label>
     <br/>
     <input type="email" className="form-control" name="email" onChange={handleChange}/>
     <br/>
     </div>

     </div>

     <label>Dirección:</label>
     <br/>
     
     <input type="text" className="form-control" name="direccion" onChange={handleChange}/>
     <br/>
 
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPost()}>Insertar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalInsertar()}>Cancelar</button>
 </ModalFooter>
</Modal>


<Modal isOpen={modalEditar}>
<ModalHeader cssModule={{'modal-title': 'w-100 text-center'}}><i class="fas fa-users-cog" style={{color:"#36BCFE"}}>
 </i> EDITAR PROVEEDOR</ModalHeader>
 <ModalBody>
   <div className="form-group">
   <div className="row">
   
     <div class="col-8">
     <label>Nombres:</label>
     <br/>
     <input type="text" className="form-control" name="nombre" onChange={handleChange}  
     value={frameworkSeleccionado && frameworkSeleccionado.nombre} />
     <br/>
     </div>
     <div class="col-sm-4">
      <label>T.doc:</label>
     <br/>
                    <select name="tdoc" className="form-control" onChange={handleChange}
                    value={frameworkSeleccionado && frameworkSeleccionado.tdoc} >
                    <option value="Cedula">Cedula</option>
                    <option value="DNI">DNI</option>
                    <option value="T. identidad">T. identidad</option>
                    <option value="T. identidad">NIT</option>
                    </select>     
                    </div>
     <div class="col-4">
     <label>Documento:</label>
     <br/>
     <input type="number" className="form-control" name="documento" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.documento} />
     <br/>
     </div>
     <div class="col-4">
     <label>Celular:</label>
     <br/>
     <input type="number" className="form-control" name="celular" onChange={handleChange} 
     value={frameworkSeleccionado && frameworkSeleccionado.celular} />
     </div>
     <div class="col-4">
     <label>Email:</label>
     <br/>
     <input type="text" className="form-control" name="email" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.email} />
     <br/>
     </div>
     <div class="col-12">
     <label>Dirección:</label>
     <br/>
     <input type="text" className="form-control" name="direccion" onChange={handleChange}
     value={frameworkSeleccionado && frameworkSeleccionado.direccion} />
     
     </div>
 
   </div>
   </div>
 </ModalBody>
 <ModalFooter>
   <button className="btn btn-primary" onClick={()=>peticionPut()}><i class="fas fa-edit"></i> Editar</button>{" "}
   <button className="btn btn-danger" onClick={()=>abrirCerrarModalEditar()}>Cancelar</button>
 </ModalFooter>
</Modal>

<Modal isOpen={modalEliminar}>
 <ModalBody>
   ¿Estas seguro que deseas eliminar el proveedor {frameworkSeleccionado && frameworkSeleccionado.nombre}?
   </ModalBody>
   <ModalFooter>
     <button className="btn btn-danger"
     onClick={()=>peticionDelete()}
     >
       SI
     </button>
     <button
       className="btn btn-secondary"
       onClick={()=>abrirCerrarModalEliminar()}
       >
         NO
     </button>

   </ModalFooter>
 
</Modal>

            </div>
       
          </div>

         
        </div>   

      </div>
    </section>
   
  </div>
     )
    }
  
    else if(showLogin){
        return "";
    }
    else{
      return <Inicio/>;
    }
    
    }

export default Proveedores
